
import Vue from 'vue';
import Component from 'vue-class-component';
import { State, Action } from 'vuex-class';

import { User } from '@/models/user.types';

import UserInterfaceFunction from '@/functions/userinterface.function';

@Component
export default class Otp extends Vue {

  /* VUEX */

  // ACTIONS
  @Action('authLayout')
  private authLayout: any;
  @Action('actionOTP', { namespace: 'user' })
  private actionOTP: any;
  @Action('actionResendOTP', { namespace: 'user' })
  private actionResendOTP: any;

  // STATE
  @State('user')
  private user: User;

  /* INITIALIZATION */

  private functionUserInterface: UserInterfaceFunction;
  private intervalCountDown: any = null;

  constructor() {
    super();

    this.functionUserInterface = new UserInterfaceFunction();
  }

  /* LIFECYCLE */

  private created() {
    this.authLayout();

    if (!this.user.token) {
      this.$router.push({name: 'signup'});
    }

    this.intervalCountDown = this.functionUserInterface.startCountDown('#resendButton', 'Resend', 2);
  }

  private beforeDestroy() {
    if (this.intervalCountDown) {
      clearInterval(this.intervalCountDown);
    }
  }

  /* METHODS */
}
